import React from 'react';

import { SelectInput} from '@sogei/react-web-components-catalog'
import { AppButton } from '../commons/button';
import { observer, inject } from "mobx-react";
import i18next from 'i18next';



@inject("rootStore")
@observer
class RicevutaFirmataENon extends React.Component {

  constructor(props) {
    super(props);
    this.item = this.props.item;
    this.element = this.props.element;
    this.ricevuteStore = props.rootStore.ricevuteStore;
    
  
  }

  componentDidMount() {
   
    
  }

 
   

  render() {

    const documentIcon = (border, icon, iconStyle, spanSrOnly, onClick,titolo) => {
        let customClass = 'btn btn-light border ' + border;
        let iconCenter = icon + ' ' + iconStyle;
        return <AppButton color="none" spanSrOnly={i18next.t(spanSrOnly)} customClass={customClass} iconCenter={iconCenter} type="button"  onClick={onClick} titleKey='' extraProps={{title:i18next.t(titolo)}}/>
      }

    
    const rd = (item,element) =>{
        let downloadInputPdf = undefined;
        let downloadInputP7m = undefined;
        let colorePdf = "info";
        let coloreP7m = "info";
        if( item[element.file+"Pdf"] instanceof Object &&  item[element.file+"P7m"] instanceof Object ){
          downloadInputPdf = {fileMetaData: item[element.file+"Pdf"]};
          downloadInputP7m = {fileMetaData: item[element.file+"P7m"]};
           colorePdf= item[element.file+"Pdf"]["colore"];
           coloreP7m= item[element.file+"P7m"]["colore"];
        }
        else{
           downloadInputPdf = {idFile: item[element.file+"Pdf"]};
           downloadInputP7m = {idFile: item[element.file+"P7m"]};
        }

        
          if(item[element.file+"Pdf"] && item[element.file+"P7m"]){

  
        //const bottonePdf = documentIcon(item[element.nomeKeyServizio] == '11' ? 'border-success' : 'border-danger','fas fa-file-pdf', item[element.nomeKeyServizio] == '11' ? 'icon-success' : 'icon-danger',element.spanSrOnlyPdf, () => {this.ricevuteStore.downloadFile(downloadInputPdf)},item[element.nomeKeyServizio] == '11' ? element.titlePdf[0] : element.titlePdf[1]) 
        //const bottoneP7m = documentIcon(item[element.nomeKeyServizio] == '11' ? 'border-success' : 'border-danger','fas fa-file-signature', item[element.nomeKeyServizio] == '11' ? 'icon-success' : 'icon-danger',element.spanSrOnlyP7m, () => {this.ricevuteStore.downloadFile(downloadInputP7m)},item[element.nomeKeyServizio] == '11' ?  element.titleP7m[0] :  element.titleP7m[1]) 
        const bottonePdf = documentIcon('border-'+colorePdf,'fas fa-file-pdf', 'icon-'+colorePdf,element.spanSrOnlyPdf, () => {this.ricevuteStore.downloadFile(downloadInputPdf)},"Ricevuta") 
        const bottoneP7m = documentIcon('border-'+coloreP7m ,'fas fa-file-signature', 'icon-'+coloreP7m,element.spanSrOnlyP7m, () => {this.ricevuteStore.downloadFile(downloadInputP7m)},"Ricevuta") 
  
            
          return [bottonePdf," ",bottoneP7m]
        }
        /*else if(item[element.file+"Pdf"]){
          return bottonePdf
        }
        else if(item[element.file+"P7m"]){
          return bottoneP7m
        }*/
        else{
            
        return " - "
        }
    }

    
  
  
  
  
  
    return (
        rd(this.item,this.element)

    );
      
    }
    

    }
    
   
  






//export default SceltaTipoInvio;

export {RicevutaFirmataENon}; 